import { DocType } from "../models/doc-types.models";

export const certificatesTypes: DocType[] = [
  {
    template: "CG",
    name: "Cargo Gear",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "SCC",
    name: "Cargo Ship Safety Construction Certificate (SCC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "SEC",
    name: "Cargo Ship Safety Equipment Certificate (SEC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "SRC",
    name: "Cargo Ship Safety Radio Certificate (SRC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "COC",
    name: "Certificate of Class (COC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "IMSBC",
    name: "Certificate of Compliance for Solid BC (IMSBC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "CIHM",
    name: "Certificate of Insurance (H&M)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "CIPI",
    name: "Certificate of Insurance (P&I)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "COR",
    name: "Certificate of Registry (COR)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "CLBC",
    name: "Civil Liability for Bunker Oil Pollution Damage Convention (CLBC) Certificate",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "COFR",
    name: "Certificate of financial responsibility (COFR)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "DOC",
    name: "Document of Compliance (DOC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "SCDG",
    name: "Document of Compliance for Ship Carrying Dangerous Goods",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "IAPPC",
    name: "International Air Pollution Prevention Certificate (IAPPC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "IAFSC",
    name: "International Anti-fouling System Certificate (IAFSC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "ILC",
    name: "International Loadline Certificate (ILC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "IOPPC",
    name: "International Oil Pollution Prevention Certificate (IOPPC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "ISPPC",
    name: "International Sewage Pollution Prevention Certificate (ISPPC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "ISSC",
    name: "International Ship Security Certificate (ISSC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "ITC",
    name: "International Tonnage Certificate (ITC)",
    docType: "Certificates",
    hasExpirationDate: false,
    hasSurveyDate: false,
  },
  {
    template: "SMC",
    name: "ISM Safety Management Certificate (SMC)",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: true,
  },
  {
    template: "ITFBC",
    name: "ITF blue card",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "SSCC",
    name: "Ship Sanitation Control (SSCC)/Ship Sanitation Control Exemption (SSCE) Certificate",
    docType: "Certificates",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
];

export const questionnairesTypes: DocType[] = [
  {
    template: "BQ",
    name: "Baltic questionnaire",
    docType: "Questionnaires",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
];

export const otherDocumentsTypes: DocType[] = [
  {
    template: "CP",
    name: "Capacity Plan",
    docType: "Other documents",
    hasExpirationDate: false,
    hasSurveyDate: false,
  },
  {
    template: "SP",
    name: "Ship’s Particulars",
    docType: "Other documents",
    hasExpirationDate: true,
    hasSurveyDate: false,
  },
  {
    template: "MS",
    name: "Mid Section",
    docType: "Other documents",
    hasExpirationDate: false,
    hasSurveyDate: false,
  },
  {
    template: "GAP",
    name: "General arrangement plan (GA Plan)",
    docType: "Other documents",
    hasExpirationDate: false,
    hasSurveyDate: false,
  },
];

export const docTypes: DocType[] = [...certificatesTypes, ...questionnairesTypes, ...otherDocumentsTypes];
